// Tiny pause store used to coordinate "paused" state across components/hooks
// without threading props everywhere.
//
// Note: This is intentionally lightweight (no Redux/Zustand dependency).

let paused = false;
const listeners = new Set();

export function getAppPaused() {
  return paused;
}

export function setAppPaused(next) {
  paused = Boolean(next);
  for (const cb of listeners) {
    try {
      cb(paused);
    } catch {
      // ignore listener errors
    }
  }
}

// Subscribe to pause changes. Returns an unsubscribe function.
export function subscribeAppPaused(cb) {
  if (typeof cb !== "function") return () => {};
  listeners.add(cb);
  return () => listeners.delete(cb);
}


